import React from 'react'

interface Props {
  children: React.ReactNode
}

const Heading: React.FC<Props> = ({ children }) => {
  return (
    <div className="flex items-center gap-4 mb-4">
      <div className="w-1 h-6 mr-2 bg-primary" />
      <h2 className="text-lg font-bold text-[24px] uppercase">{children}</h2>
    </div>
  )
}

export default Heading
